import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { expensesType_response } from "../../../services/api/api";

// Models


// Show recipt voucher state
export interface showExpensesTypeState {
    isLoaded: boolean;
    isOpen: boolean;
    id: number;
    data: expensesType_response;
}

const initialShowExpensesTypeState: showExpensesTypeState = {
    isLoaded: false,
    isOpen: false,
    id: 0,
    data: {}
}

// Show recipt voucher slice
export const showExpensesTypeSlice = createSlice({
    name: 'show_expenses_type',
    initialState: initialShowExpensesTypeState,
    reducers: {
        setIsLoaded: ( state, {payload}: PayloadAction<boolean> ) => {
            state.isLoaded = payload
        },
        setData: ( state, {payload}: PayloadAction<expensesType_response> ) => {
            state.data = payload
        },
        setIsOpen: ( state, {payload}: PayloadAction<{ id: number, isOpen: boolean }> ) => {
            state.isOpen = payload.isOpen
            state.id = payload.id
        }
    }
})